/**
 * Dynamic image loading utilities using Vite's import.meta.glob
 *
 * This module provides a production-ready approach to loading images from
 * the filesystem. Images are resolved at build time, eliminating the need
 * for hardcoded imports when adding/removing images.
 */

// Eager load all images from the about directory at build time
export const aboutImages = import.meta.glob<{ default: string }>(
    '/src/assets/images/about/*.{jpg,jpeg,JPG,JPEG,png,gif,webp}',
    { eager: true }
)

// Eager load all images from the media-helper directory at build time
export const mediaHelperImages = import.meta.glob<{ default: string }>(
    '/src/assets/images/portfolio/media-helper/*.{png,jpg,jpeg,gif,webp}',
    { eager: true }
)

/**
 * Extract image URLs from a glob result object
 * @param globResult - The result from import.meta.glob with eager: true
 * @returns Array of image URLs sorted alphabetically by path
 */
export function getImageUrls(
    globResult: Record<string, { default: string }>
): string[] {
    return Object.entries(globResult)
        .sort(([pathA], [pathB]) => pathA.localeCompare(pathB))
        .map(([, module]) => module.default)
}
